/**
 * Collection grid: Select size → popover on CTA → Add to cart (AJAX).
 */

function readWethemeTranslations() {
  const el = document.querySelector('script#wetheme-global');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent).translations || {};
  } catch {
    return {};
  }
}


function pageContext() {
  const pc = document.getElementById('PageContainer');
  if (!pc) {
    return { cartType: 'drawer', cartAction: 'show_added_message', languageUrl: '' };
  }
  return {
    cartType: pc.dataset.cartType || 'drawer',
    cartAction: pc.dataset.cartAction || 'show_added_message',
    languageUrl: pc.dataset.languageUrl || '',
  };
}

function cartAddUrl() {
  if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
  return '/cart/add.js';
}

const SPINNER_SVG =
  '<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" class="spin flex-full"><g clip-path="url(#clip0_cvp)"><path d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 15.1767 22.1534 18.0388 20 20.0468" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_cvp"><rect width="24" height="24" fill="none" transform="translate(0.5)"/></clipPath></defs></svg>';

const SUCCESS_CHECK_SVG =
  '<svg class="collection-card-variants__check" viewBox="0 0 24 24" width="1.2em" height="1.2em" aria-hidden="true" focusable="false"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>';

class CollectionCardVariants {
  constructor(card) {
    this.card = card;
    const scriptEl = card.querySelector('[data-cvp-variants]');
    if (!scriptEl) return;

    try {
      this.variants = JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('[collection-card-variants] Invalid variant JSON', e);
      return;
    }

    this.isMulti = this.variants.length > 1;
    this.popover = card.querySelector('[data-cvp-popover]');
    this.ctaBlocks = card.querySelectorAll('[data-cvp-ctas]');
    /* Sibling .grid__item cells stack above one another; lift this cell so the popover clears neighbors */
    this.gridItem = card.closest('.grid__item');
    /* Outer Shopify wrapper (not inner <section class="shopify-section">), so z-index beats the next page section */
    this.popoverSection = card.closest('[id^="shopify-section-"]');
    this.t = readWethemeTranslations();
    this.page = pageContext();
    const preferredId = scriptEl.dataset.defaultVariantId ? Number(scriptEl.dataset.defaultVariantId) : null;
    this.selectedId = this.resolveInitialVariantId(preferredId);
    this.processing = false;
    this._dismissAttached = false;
    /** Ignore window scroll / stray touchmove right after open (scrollIntoView used to scroll the page and closed the picker). */
    this._dismissIgnoreUntil = 0;
    this.sizeSummaryEl = card.querySelector('[data-cvp-size-summary]');
    this.sizeValueEl = card.querySelector('[data-cvp-size-value]');
    this.variantPickedForSummary = false;

    this._onVariantClick = this.onVariantClick.bind(this);
    this._onAdd = (e) => this.handleAdd(e);
    this._onMorphClick = this.onMorphCtaClick.bind(this);
    this._onDocClick = this.onDocClick.bind(this);
    this._onTouchEnd = this.onTouchEnd.bind(this);
    this._onKeydown = this.onKeydown.bind(this);
    this._onWindowScroll = this.onWindowScrollDismiss.bind(this);
    this._onTouchMoveDoc = this.onTouchMoveDismiss.bind(this);

    this.bindVariantRows();
    this.bindCtas();

    const sizeEdit = card.querySelector('[data-cvp-size-edit]');
    if (sizeEdit) {
      sizeEdit.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.isMulti || this.processing) return;
        this.openSelector();
      });
    }

    this.syncSelectionState();
    const initial = this.variants.find((v) => v.id === this.selectedId);
    this.updatePriceForVariant(initial);
    this.updateCardImageForVariant(initial);
    this.refreshMorphLabels();
  }

  firstAvailableId() {
    const v = this.variants.find((x) => x.available);
    return v ? v.id : this.variants[0].id;
  }

  resolveInitialVariantId(preferredId) {

    if (
      preferredId != null &&
      !Number.isNaN(preferredId) &&
      this.variants.some((v) => v.id === preferredId && v.available)
    ) {
      return preferredId;
    }
    return this.firstAvailableId();
  }

  isSelectorOpen() {
    return this.card.classList.contains('cvp-selector-is-open');
  }

  bindVariantRows() {
    this.card.querySelectorAll('[data-cvp-variant-id]').forEach((btn) => {
      btn.addEventListener('click', this._onVariantClick);
    });
  }


  bindCtas() {
    this.ctaBlocks.forEach((block) => {
      block.querySelectorAll('[data-cvp-add]').forEach((b) => b.addEventListener('click', this._onAdd));
      block.querySelectorAll('[data-cvp-morph-cta]').forEach((b) => b.addEventListener('click', this._onMorphClick));
    });
  }

  attachDismissListeners() {
    if (this._dismissAttached) return;
    this._dismissAttached = true;
    /* Defer so the same click that opened the selector does not run dismiss in the same tick */
    requestAnimationFrame(() => {
      if (!this.isSelectorOpen() || !this._dismissAttached) return;
      document.addEventListener('click', this._onDocClick, true);
      /* iOS often does not synthesize document click for touch outside; touchend does fire */
      document.addEventListener('touchend', this._onTouchEnd, true);
      document.addEventListener('keydown', this._onKeydown, true);
      /* Page scroll (mobile + desktop): close when the list itself isn’t what’s scrolling */
      window.addEventListener('scroll', this._onWindowScroll, true);
      document.addEventListener('touchmove', this._onTouchMoveDoc, true);
    });
  }

  detachDismissListeners() {
    if (!this._dismissAttached) return;
    this._dismissAttached = false;
    document.removeEventListener('click', this._onDocClick, true);
    document.removeEventListener('touchend', this._onTouchEnd, true);
    document.removeEventListener('keydown', this._onKeydown, true);
    window.removeEventListener('scroll', this._onWindowScroll, true);
    document.removeEventListener('touchmove', this._onTouchMoveDoc, true);
  }

  _now() {
    return typeof performance !== 'undefined' && typeof performance.now === 'function'
      ? performance.now()
      : Date.now();
  }

  onWindowScrollDismiss() {
    if (!this.isSelectorOpen()) return;
    if (this._now() < this._dismissIgnoreUntil) return;
    this.closeSelector();
  }

  /**
   * Mobile: scrolling the page doesn’t always fire click/touchend outside; touchmove outside the
   * CTA+popover closes the selector (touch inside [data-cvp-ctas] is ignored).
   */
  onTouchMoveDismiss(e) {
    if (!this.isSelectorOpen()) return;
    if (this._now() < this._dismissIgnoreUntil) return;
    if (this.isEventInsideThisSelectorUi(e)) return;
    this.closeSelector();
  }

  /**
   * Only this card's [data-cvp-ctas] (CTA + popover) counts as "inside".
   * Global t.closest('[data-cvp-ctas]') matched *any* product's wrapper and blocked dismiss.
   */
  isEventInsideThisSelectorUi(e) {
    const t = e.target;
    if (!t || typeof t.closest !== 'function') return false;
    const root = this.card.querySelector('[data-cvp-ctas]');
    return !!(root && root.contains(t));
  }

  onDocClick(e) {
    if (!this.isSelectorOpen()) return;
    if (this.isEventInsideThisSelectorUi(e)) return;
    this.closeSelector();
  }

  onTouchEnd(e) {
    if (!this.isSelectorOpen()) return;
    if (this.isEventInsideThisSelectorUi(e)) return;
    this.closeSelector();
  }

  onKeydown(e) {
    if (e.key !== 'Escape' || !this.isSelectorOpen()) return;

    this.closeSelector();
  }

  onMorphCtaClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isMulti || this.processing) return;

    if (!this.isSelectorOpen()) {
      /*
        Morph label shows “Add to cart” when a size was chosen (summary row / variantPickedForSummary).
        First click must add, not reopen the picker — otherwise users need two taps.
      */
      if (this.variantPickedForSummary || this.card.classList.contains('cvp-size-summary-visible')) {
        this.handleAdd(e);
        return;
      }
      this.openSelector();
      return;
    }

    this.handleAdd(e);
  }

  onVariantClick(e) {
    const btn = e.currentTarget;
    const id = Number(btn.dataset.cvpVariantId);
    if (!id || btn.disabled || btn.classList.contains('is-disabled')) return;
    this.variantPickedForSummary = true;
    this.selectedId = id;
    this.syncSelectionState();
    const v = this.variants.find((x) => x.id === id);
    this.updatePriceForVariant(v);
    this.updateCardImageForVariant(v);
    if (this.isSelectorOpen()) {
      this.closeSelector();
    } else {
      this.refreshMorphLabels();
    }
  }

  /**
   * Update the product card price block to match the selected variant (theme: .product-grid--price).
   */
  updatePriceForVariant(variant) {
    if (!variant) return;
    const priceRoot = this.card.querySelector('.product-grid--price');
    if (!priceRoot) return;

    const saleWrap = priceRoot.querySelector('.product-price--sale');
    const regWrap = priceRoot.querySelector('.product-price--regular');
    const saleEl = priceRoot.querySelector('.price--sale-price');
    const compareEl = priceRoot.querySelector('.price--compare-at-price');
    const regularEl = priceRoot.querySelector('.price--regular-price');
    priceRoot.querySelectorAll('.price--from-text').forEach((el) => el.classList.add('hidden'));

    const priceN = Number(variant.price);
    const compareN = Number(variant.compare_at_price);
    const onSale = !Number.isNaN(priceN) && !Number.isNaN(compareN) && compareN > priceN;

    const money = (s) => (s == null ? '' : String(s));

    if (onSale) {
      if (saleWrap) saleWrap.classList.remove('hidden');
      if (regWrap) regWrap.classList.add('hidden');
      if (saleEl) saleEl.innerHTML = money(variant.price_formatted);
      if (compareEl) {
        const vh = compareEl.querySelector('.visually-hidden');
        const head = vh ? vh.outerHTML : '';
        compareEl.innerHTML = head + money(variant.compare_at_price_formatted);
      }
    } else {
      if (saleWrap) saleWrap.classList.add('hidden');
      if (regWrap) regWrap.classList.remove('hidden');
      if (regularEl) regularEl.innerHTML = money(variant.price_formatted);
    }
  }

  /**
   * Swap card image to the selected variant’s featured image (PDP-style).
   */
  updateCardImageForVariant(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;

    const fi = variant.featured_image;
    const main = this.card.querySelector('img[data-product-card-image]');
    if (!main) return;

    main.src = fi.src;
    if (fi.srcset) {
      main.srcset = fi.srcset;
    } else {
      main.removeAttribute('srcset');
    }
    if (fi.sizes) {
      main.sizes = fi.sizes;
    }
    main.alt = typeof fi.alt === 'string' ? fi.alt : '';
    if (fi.width) main.setAttribute('width', String(fi.width));
    if (fi.height) main.setAttribute('height', String(fi.height));
    main.style.opacity = '1';

    const swatch = this.card.querySelector('img[data-product-card-swatch-image]');
    if (swatch) {
      swatch.removeAttribute('srcset');
      swatch.style.opacity = '0';
    }

    const secondary = this.card.querySelector('.product-card__image--secondary');
    if (secondary) {
      secondary.style.opacity = '0';
      secondary.style.pointerEvents = 'none';
      secondary.setAttribute('aria-hidden', 'true');
    }
  }

  syncSelectionState() {
    this.card.querySelectorAll('[data-cvp-variant-id]').forEach((btn) => {
      const id = Number(btn.dataset.cvpVariantId);
      const on = id === this.selectedId;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  hideSizeSummary() {
    if (this.sizeSummaryEl) this.sizeSummaryEl.hidden = true;
    this.card.classList.remove('cvp-size-summary-visible');
  }

  syncSizeSummaryVisibility() {
    if (!this.variantPickedForSummary || !this.sizeSummaryEl || !this.isMulti) return;
    if (this.isSelectorOpen()) return;
    const v = this.variants.find((x) => x.id === this.selectedId);
    if (!v) return;
    if (this.sizeValueEl) this.sizeValueEl.textContent = (v.display_name || '').trim();
    this.sizeSummaryEl.hidden = false;
    this.card.classList.add('cvp-size-summary-visible');
  }

  openSelector() {
    if (!this.isMulti || !this.popover) return;

    this.hideSizeSummary();
    this.syncSelectionState();
    this.popover.hidden = false;
    this.card.classList.add('cvp-selector-is-open');
    if (this.gridItem) this.gridItem.classList.add('cvp-grid-item--popover-open');
    if (this.popoverSection) this.popoverSection.classList.add('cvp-section--popover-elevated');
    this.attachDismissListeners();
    this.refreshMorphLabels();
    /* Don’t let scroll-dismiss fire from our own list scroll / layout (2nd open glitch on mobile). */
    this._dismissIgnoreUntil = this._now() + 650;
    this.queueScrollSelectedIntoView();
  }

  closeSelector() {
    this.detachDismissListeners();
    this.card.classList.remove('cvp-selector-is-open');
    if (this.gridItem) this.gridItem.classList.remove('cvp-grid-item--popover-open');
    if (this.popoverSection) this.popoverSection.classList.remove('cvp-section--popover-elevated');
    if (this.popover) this.popover.hidden = true;
    if (!this.processing) {
      this.syncSizeSummaryVisibility();
      this.refreshMorphLabels();
    }
  }

  queueScrollSelectedIntoView() {
    requestAnimationFrame(() => {
      const root = this.card.querySelector('[data-cvp-list]');
      if (!root) return;
      const sel = root.querySelector('[data-cvp-variant-id].is-selected');
      if (!sel) return;
      /*
        Only scroll the popover list — NOT scrollIntoView on the row (that scrolls ancestor chain /
        window, fires window "scroll", and our dismiss handler closed the picker on 2nd open).
      */
      const viewH = root.clientHeight;
      const elTop = sel.offsetTop;
      const elH = sel.offsetHeight;
      const maxScroll = Math.max(0, root.scrollHeight - viewH);
      let next = elTop - (viewH - elH) / 2;
      if (next < 0) next = 0;
      if (next > maxScroll) next = maxScroll;
      root.scrollTop = next;
    });
  }

  refreshMorphLabels() {
    const selectorOpen = this.isSelectorOpen();
    const summaryVisible = this.card.classList.contains('cvp-size-summary-visible');
    const showAdd = selectorOpen || summaryVisible;

    this.card.querySelectorAll('[data-cvp-morph-cta]').forEach((btn) => {
      const primary = btn.querySelector('.cvp-cta__primary');
      const summary = btn.querySelector('.cvp-cta__summary');
      const labelSelect = btn.dataset.cvpLabelSelect || 'Select Size';
      const labelAdd = btn.dataset.cvpLabelAdd || 'Add to cart';

      if (primary) {
        primary.textContent = showAdd ? labelAdd : labelSelect;
      }

      if (summary) {
        summary.textContent = '';
        summary.hidden = true;
        summary.setAttribute('aria-hidden', 'true');
      }

      btn.setAttribute('aria-expanded', selectorOpen ? 'true' : 'false');
      btn.setAttribute('aria-label', showAdd ? labelAdd : labelSelect);
    });
  }

  restoreMorphMarkup(morph) {
    if (!morph || !morph.matches('[data-cvp-morph-cta]')) return;
    const labelSelect = morph.dataset.cvpLabelSelect || 'Select Size';
    morph.innerHTML = `<span class="cvp-cta__primary"></span><span class="cvp-cta__summary" hidden aria-hidden="true"></span>`;
    morph.querySelector('.cvp-cta__primary').textContent = labelSelect;
    morph.setAttribute('aria-expanded', 'false');
    morph.setAttribute('aria-label', labelSelect);
  }

  async handleAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.processing) return;

    const variant = this.variants.find((v) => v.id === this.selectedId);
    if (!variant || !variant.available) return;

    const btn = e.currentTarget;
    const prevHtml = btn.innerHTML;
    this.processing = true;

    btn.style.minWidth = `${Math.ceil(btn.getBoundingClientRect().width)}px`;
    btn.innerHTML = `${SPINNER_SVG}<span class="sr-only">${this.t.loading || ''}</span>`;
    btn.classList.add('is-loading');
    btn.disabled = true;

    const payload = {
      items: [{ id: this.selectedId, quantity: 1 }],
    };
    if (this.page.cartType === 'drawer') {
      payload.sections = 'cart-drawer';
    }

    try {
      const res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg = data.description || data.message || res.statusText || 'Cart error';
        window.alert(msg);
        btn.classList.remove('is-loading');
        btn.style.minWidth = '';
        btn.innerHTML = prevHtml;
        btn.disabled = false;
        return;
      }

      /*
        Close popover + stacking before cart drawer re-renders. If update:cart:drawer runs while the
        selector overlay and elevated section are still active, trapFocus + DOM updates can leave
        mobile Safari unable to scroll the page (multi-variant path only had the overlay open).
      */
      this.closeSelector();
      /* After add: hide size row + pencil so the card resets; don’t re-show summary in finally */
      this.variantPickedForSummary = false;
      this.hideSizeSummary();

      const ae = document.activeElement;
      if (ae && this.card.contains(ae) && typeof ae.blur === 'function') {
        ae.blur();
      }

      if (this.page.cartType === 'drawer' && window.eventBus) {
        window.eventBus.emit('update:cart:drawer', data);
      }

      this.refreshCartCount();

      const addedTemplate = this.ctaBlocks[0] && this.ctaBlocks[0].dataset.productAdded;
      const live = this.card.querySelector('[data-cvp-live]');
      if (live && addedTemplate) {
        live.textContent = addedTemplate;
      }

      const addedSr = this.t.productAdded || this.t.added || 'Added';
      const revertMs = 1800;

      btn.classList.remove('is-loading', 'loading');
      btn.style.minWidth = `${Math.ceil(btn.getBoundingClientRect().width)}px`;
      btn.innerHTML = `${SUCCESS_CHECK_SVG}<span class="sr-only">${addedSr}</span>`;
      btn.classList.add('cvp-btn-success');
      btn.disabled = true;

      setTimeout(() => {
        btn.style.minWidth = '';
        btn.classList.remove('cvp-btn-success');
        btn.disabled = false;
        if (btn.matches('[data-cvp-morph-cta]')) {
          this.restoreMorphMarkup(btn);
        } else {
          btn.innerHTML = prevHtml;
        }
        this.refreshMorphLabels();
      }, revertMs);
    } catch (err) {
      console.error('[collection-card-variants]', err);
      window.alert(this.t.error || 'Something went wrong');
      btn.classList.remove('is-loading');
      btn.style.minWidth = '';
      btn.innerHTML = prevHtml;
      btn.disabled = false;
    } finally {
      this.processing = false;
      /* Summary was cleared on successful add; restore row only if add failed / early return */
      this.syncSizeSummaryVisibility();
      this.refreshMorphLabels();
    }
  }

  refreshCartCount() {
    const lang = !this.page.languageUrl || this.page.languageUrl === '/' ? '' : this.page.languageUrl;
    fetch(`${lang}/cart?view=compare`)
      .then((r) => r.json())
      .then((cart) => {
        if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
          window.wetheme.updateCartCount(cart);
        }
      })
      .catch(() => {});
  }
}

function initCollectionCardVariants() {
  document.querySelectorAll('product-card').forEach((card) => {
    if (!card.querySelector('[data-cvp-variants]')) return;
    if (card.dataset.cvpInit === '1') return;
    card.dataset.cvpInit = '1';
    new CollectionCardVariants(card);
  });
}

document.addEventListener('DOMContentLoaded', initCollectionCardVariants);
document.addEventListener('shopify:section:load', initCollectionCardVariants);
